import { IconPlayTriangle } from '@leland-dev/leland-ui-library';
import React, { useState } from 'react';

import YouTubeEmbed from '../common/YouTubeEmbed';

interface BootcampVideoProps {
  className?: string;
  youtubeId: string;
  thumbnailLink: string;
}

export const BootcampVideo: React.FC<BootcampVideoProps> = ({
  className,
  youtubeId,
  thumbnailLink,
}) => {
  const [showYouTubeEmbed, setShowYouTubeEmbed] = useState(false);

  const imageBgStyle: Pick<React.CSSProperties, 'backgroundImage'> = {
    backgroundImage: `linear-gradient(to top, var(--tw-gradient-stops)), url(${thumbnailLink})`,
  };

  const playButton = (
    <div
      className={`flex size-10 shrink-0 items-center justify-center rounded-full bg-white/40 group-hover:bg-white/60`}
    >
      <IconPlayTriangle className={`size-4 text-white`} />
    </div>
  );

  return (
    <div className={`flex max-w-xl flex-col ${className}`}>
      {showYouTubeEmbed ? (
        <YouTubeEmbed
          className={`size-full rounded-lg`}
          youtubeId={youtubeId}
        />
      ) : (
        <button
          className={`group flex size-full flex-1 items-center justify-center rounded-lg from-black/40 bg-center bg-no-repeat p-4 shadow-inner hover:from-black/60`}
          style={imageBgStyle}
          onClick={() => setShowYouTubeEmbed(true)}
          id="bootcamp_page--play_video"
        >
          <div className="flex items-center justify-start space-x-2">
            {playButton}
          </div>
        </button>
      )}
    </div>
  );
};
